<template>
<div class="home-page">
  <div class="p-t-sm" style="padding-bottom: 30px;" id="home-top-area">
    <template></template>

  </div>

  <!--<div>-->
    <!--<div class="inner-content" id="home-info-area">-->
      <!--<button class="pull-right c-b c-b-all m-t" @click="seeNewsList()">全部</button>-->
      <!--<h3 class="content-h">婚礼资讯</h3>-->
      <!--<div class="content-d">Wedding information</div>-->
      <!--{{/** actuall content here */ }}-->
      <!--<div class="line2 m-t-30"></div>-->
      <!--<div class="clearfix m-t-30">-->
      <!--<div class="m-t-30" v-for="(item,index) in newsList" @click="goPosterDetail(item.uuid)">-->
        <!--{{/** use background for image */}}-->
        <!--<div class="clearfix news-info">-->
        <!--<div class="f-5 pull-right m-t-89">浏览：{{item.viewNumber}}次</div>-->
        <!--<div class="f-1 m-t-11">{{item.title}}</div>-->
        <!--<div class="f-2 m-t-3">{{item.createTime.substring(0,10)}}</div>-->
        <!--<div class="rectangle-theme f-3  m-t-12">{{item.themeTitle}}</div>-->
        <!--<div v-if="item.type !== 4">-->
          <!--<div class="line2 m-t-20"></div>-->
          <!--<div class="rectangle-textarea f-4 clamp m-t-20">{{item.content[0].text}}</div>-->
        <!--</div>-->
        <!--<div v-if="item.type === 4">-->
          <!--<div class="line2 m-t-20"></div>-->
          <!--<div class="rectangle-textarea f-4 clamp m-t-20">{{item.content.text}}</div>-->
        <!--</div>-->
      <!--</div>-->
        <!--<div class="img-n-div img-style" v-bind:style="{backgroundImage: 'url(' + item.cover + ')'}"></div>-->
        <!--<div class="line2 m-t-30"></div>-->
      <!--</div>-->
    <!--</div>-->
    <!--</div>-->
  <!--</div>-->


  <div>
    <div class="inner-content" id="home-info-area">
      <button class="pull-right c-b c-b-all m-t" @click="seeNewsList()">全部</button>
      <h3 class="content-h">婚礼资讯</h3>
      <div class="content-d">Wedding information</div>
      {{/** actuall content here */ }}
      <div class="line2 m-t-30"></div>
      <div class="clearfix m-t-30">
        <div class="m-t-30" v-for="(item,index) in newsList" @click="goPosterDetail(item.uuid)">
          {{/** use background for image */}}
        <div class="clearfix news-info">
          <div class="f-5 pull-right m-t-89">浏览：{{item.viewNumber}}次</div>
          <div class="f-1 m-t-11 c-p">{{item.title}}</div>
          <div class="f-2 m-t-3">{{item.createTime.substring(0,10)}}</div>
          <div class="rectangle-theme f-3  m-t-12">{{item.themeTitle}}</div>
          <div v-if="item.type !== 4 && item.content[0] != null">
            <div class="line2 m-t-20"></div>
            <div class="rectangle-textarea f-4 clamp m-t-20">{{item.content[0].text}}</div>
          </div>
          <div v-if="item.type === 4">
            <div class="line2 m-t-20"></div>
            <div class="rectangle-textarea f-4 clamp m-t-20">{{item.content.text}}</div>
          </div>
        </div>
          <div class="img-n-div img-c-div" v-bind:style="{backgroundImage: 'url(' + item.cover + ')'}"></div>
          <div class="line2 m-t-30"></div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import toastr from 'mini-toastr';
import { Carousel, Slide } from 'vue-carousel';
import $ from 'jquery';
import apiService from '../service/apiHelper';
import bus from '../utils/bus';
import uService from '../service/user';
import '../../node_modules/slick-carousel/slick/slick.css';
import '../../node_modules/slick-carousel/slick/slick-theme.css';
import '../../node_modules/slick-carousel/slick/slick.min';

// change the signature of carousel's auto play

Carousel.mixins[0].methods.startAutoplay = function startAutoplay() {
  if (this.autoplay) {
    this.autoplayInterval = setInterval(() => {
      if (!this.canAdvanceForward) {
        this.goToPage(0);
      } else {
        this.advancePage();
      }
    }, this.autoplayTimeout);
  }
};

export default {
  name: 'Index',
  data() {
    return {
      bannerList: [],
      recmdList: [],
      videoCaseList: [],
      categoryList: [],
      newsList: [],
      slides: 2,
      caseInfo: {},
    };
  },
  methods: {
    openUrl(webUrl) {
      window.open(webUrl);
    },
    goToUrl(webUrl) {
//      location.href = webUrl;
      window.open(webUrl);
    },
    gotoCase(id) {
//      this.$router.push({ name: 'CaseDetail', params: { id } });
      window.open(`#/CaseDetail/${id}`);
    },
    seeAllOfCateg(categoryId) {
//      this.$router.push({ name: 'List', query: { categoryId } });
      window.open(`#/list?categoryId=${categoryId}`);
    },
    seeVideoList() {
//      this.$router.push({ name: 'List', query: { hasVideo: 1 } });
      window.open('#/list?hasVideo=1');
    },
    videoPrevious() {
      const vcarousel = this.$refs.vcarousel;
      vcarousel.advancePage('backward');
    },
    videoNext() {
      const vcarousel = this.$refs.vcarousel;
      vcarousel.advancePage('forward');
    },
    favorCaseInfo(caseInfo) {
      if (!uService.hasLogin()) {
        toastr.error('请登录后收藏');
        return;
      }
      apiService.favorCase(caseInfo.id).then(() => {
        this.$set(caseInfo, 'isFavored', true);
        const newFavorNum = caseInfo.favorNum + 1;
        this.$set(caseInfo, 'favorNum', newFavorNum);
      });
    },
    unFavorCaseInfo(caseInfo) {
      if (!uService.hasLogin()) {
        toastr.error('请登录后取消收藏');
        return;
      }
      apiService.unFavorCase(caseInfo.id).then(() => {
        this.$set(caseInfo, 'isFavored', false);
        const newFavorNum = caseInfo.favorNum - 1;
        this.$set(caseInfo, 'favorNum', newFavorNum);
      });
    },
    seeNewsList() {
//      this.$router.push({ name: 'News' });
      window.open('#/news');
    },
    goPosterDetail(id) {
//      this.$router.push({ name: 'NewsDetail', params: { id } });
      window.open(`#/NewsDetail/${id}`);
    },
    updateSlick() {
      const fun = $('.slick').slick;
      if (fun !== undefined) {
        $('.slick').slick({
          autoplay: true,
          dots: true,
          responsive: [{
            speed: 1500,
            settings: {
              arrows: false,
              infinite: true,
              slidesToShow: 1,
              fade: true,
            },
          }],
        });
      }
    },
  },
  created() {
    apiService.getHomePage().then((resp) => {
      console.log(resp);
      // this.bannerList = resp.data.banner_list;
      // this.recmdList = resp.data.recmd_list;
      // this.videoCaseList = resp.data.video_case_list.slice(0, 6);
      // this.categoryList = resp.data.category_list;
      // this.newsList = resp.data.news_list;
      this.bannerList = [];
      this.recmdList = [];
      this.videoCaseList = [];
      this.categoryList = [];
      this.newsList = resp.data.news_list;
      const categNameArr = [];
      this.categoryList.forEach((categ) => {
        categNameArr.push(categ.name);
      });
      bus.$emit('CATEG_CHANGED', categNameArr);
    }, () => {
      toastr.error('首页加载失败');
    });
    $(document).ready(() => {
      $('#video-bride').bind('contextmenu', false);
    });
  },
  updated() {
    window.setTimeout(this.updateSlick, 1000);
//    $('video').bind('contextmenu', () => {
//      return false;
//    });
  },
  mounted() {},
  components: {
    Carousel,
    Slide,
  },
};
</script>
<style>
.home-page > div {
  padding: 60px 0;
}
.home-page > div.p-t-sm {
  padding-top: 0px;
}
.home-page > div:nth-child(2n) {
  background-color: #f3f3f3;
}
.home-carousel{
  width: 960px;
  height: auto;
  overflow: hidden;
}
.carousel-item{
  width: 960px;
  height: 440px;
}
.video-carousel{
  width: 100%;
  height: 620px;
  overflow: hidden;
}
.video-carousel-item{
  width: 100%;
  height: 600px;
}
.b-1-r {
  width: 230px;
}
.b-1-r-1 {
  height: 274px;
  position: relative;
  padding: 20px 35px 20px 52px;
  border: solid 1px #e1e1e1;
  background-image: url(../assets/home_only_bg.png);
  background-size: cover;
}
.b-1-r-1 h3 {
  margin: 0;
  font-size: 18px;
  color: #252525;
  margin-bottom: 5px;
  position: relative;
}
.b-1-r-1 h3::before {
  content: '';
  width: 4px;
	height: 16px;
	background-color: #ba882a;
  position: absolute;
  left: -14px;
  top: 5px;
}
.b-1-r-2 {
  height: 82px;
  margin-top: 10px;
  background-image: url(../assets/ewm-bj.png);
  padding: 16px 0 16px 16px;
}
.b-1-r-1-t {
  position: absolute;
  left: 0;
  top: 0;
  height: 59px;
  width: 64px;
  background-image: url(../assets/b-1-r-t.png);
  background-size: cover;
}
.b-1-r-c {
  color: #787878;
  line-height: 1.71;
  font-size: 14px;
}
.b-1-r-1 h3.b-1-m-t {
  margin-top: 20px;
}
.b-1-q-r {
  height: 80px;
  width: 80px;
  margin-right: 10px;
}
.b-1-r-2 h3 {
  font-size: 20px;
  color: #ab7620;
  margin-bottom: 10px;
  margin-top: 0;
}
.b-1-r-2 > span {
  display: inline-block;
  position: relative;
  top: -5px;
}
.b-1-r-2 > span > span {
  color: #525252;
  font-size: 14px;
  line-height: normal;
}
.content-h {
  margin: 0;
  font-size: 20px;
  color: #ba882a;
  font-weight: 600;
}
.content-d {
  font-size: 12px;
  color: #979797;
  margin-bottom: 30px;
}
.rcmd-1 {
  width: calc(100% / 3 - 47px);
  height: 554px;
  margin-right: 15px;
}
.rcmd-special {
  width: calc(100% / 3);
  border: solid 1px #e1e1e1;
  position: relative;
  background-color: #fff;
  margin-right: 15px;
}
.rcmd-c {
  border: solid 1px #e1e1e1;
  position: relative;
  background-color: #fff;
}
.rcmd-rcmd {
  position: absolute;
  top: 0;
  right: 30px;
  z-index: 2;
}
.rcmd-pic {
  display: block;
  height: 100%;
  width: 100%;
}
.rcmd-r-wrp .rcmd-c {
  width: calc(100% / 3);
  height: 268px;
}
.rcmd-r-wrp > div:nth-child(1) {
  margin-right: 15px;
  margin-bottom: 15px;
}
.rcmd-r-wrp > div:nth-child(2) {
  margin-bottom: 15px;
}
.rcmd-r-wrp > div:nth-child(3) {
  margin-right: 15px;
}
.c-b-all {
  border-radius: 1px;
	background-color: #dcbd82;
  color: #ffffff;
  padding: 3px 14px;
  font-size: 12px;
  border: 0 none;
  cursor: pointer;
}
.v-c {
	background-color: #ffffff;
}
.rect {
  width: 100%;
  padding-top: 100%;
}
.v-c-text {
  padding: 20px 30px 30px 30px;
}
.v-c-text h3 {
  margin-top: 0;
  color: #252525;
}
.v-c:hover {
  background-color: #ba882a;
}
.v-c:hover .gray-1,
.v-c:hover .gray-2,
.v-c:hover .v-c-text h3 {
  color: #ffffff;
}
.dot-wrp {
  text-align: center;
}
.dot-wrp > div {
  display: inline-block;
  width: 6px;
  height: 6px;
  cursor: pointer;
  border-radius: 50%;
}
.m-a {
  margin: 0px;
}
.img-c-div {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

  /*资讯样式*/

.img-n-div {
  display: block;
  height: 220px;
  width: 35%;
  /*border: 1px solid gainsboro;*/
  box-sizing: border-box;
}

img-style{
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.news-info {
  display: block;
  box-sizing: border-box;
  width: 63%;
  float: right;
  /*vertical-align: middle;*/
}

.m-t-30 {
  margin-top: 30px;
}

.m-t-12 {
  margin-top: 12px;
}

.m-t-3 {
  margin-top: 3px;
}

.m-t-20 {
  margin-top: 20px;
}

.m-t-60 {
  margin-top: 60px;
}

.m-t-11 {
  margin-top: 11px;
}

.m-t-89 {
  margin-top: 89px;
}

.m-b-44 {
  margin-bottom: 44px;
}

.line2 {
  width: 100%;
  border-bottom: 1px #c1c1c1 dashed;
}

.f-1 {
  font-size: 18px;
  color: #252525;
  /*text-shadow: 0 1px 3px rgba(0, 0 , 0, 0.5);*/
  line-height: 25px;
}

.f-1:hover {
  font-size: 18px;
  color: #ba882a;
  /*text-shadow: 0 1px 3px #ba882a;*/
  line-height: 25px;
}

.f-1-selected {
  font-size: 18px;
  color: #ba882a;
  /*text-shadow: 0 1px 3px #ba882a;*/
  line-height: 25px;
}

.f-2 {
  font-size: 14px;
  color: #c1c1c1;
  line-height: 22px;
}

.f-3 {
  font-size: 14px;
  color: #df3a4e;
}

.f-4 {
  font-size: 12px;
  /*line-height: 22px;*/
  line-height: 1.83;
  color: #525252;
  font-weight: 300;
}

.f-5 {
  font-size: 12px;
  color: #a9a9a9;
  font-weight: 300;
  line-height: 17px;
}

.rectangle-theme {
  width: 99.8px;
  height: 28px;
  border-radius: 1px;
  border: solid 1px #df3a4e;
  text-align: center;
  line-height: 28px;
}

.rectangle-textarea {
  width: 100%;
}

.clamp {
  word-break:break-all;
  display:-webkit-box;
  -webkit-line-clamp:3;
  -webkit-box-orient:vertical;
  overflow:hidden;
}
.slick-dots {
  position: static !important;
}
.m-b-15 {
  /*margin-top: 10px;*/
  margin-bottom: 15px;
}
.f-6 {
  font-size: 16px;
  color: #525252;
  font-weight: bold;
}
.f-7{
  font-size: 16px;
  color: #787878;
  font-weight: lighter;
}
.div-inl{
  display: inline-block;
}
.video-height{
  height: 195px;
}

video {
  width: 100%;
  height: auto;
  display: block;
  /*background:transparent url('../assets/video.png')  50% 50% no-repeat;*/
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// Index.vue?5bb32ac5